const ArrowDown = ({ height = "26", stroke = "#F4F4F4" }) => (
  <svg
    width="26"
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.67676 4.82981L16.5783 11.7313C17.3933 12.5464 17.3933 13.8801 16.5783 14.6952L9.67676 21.5967"
      stroke={stroke}
      strokeWidth="3.10498"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDown;
